import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface BangTongHopHoaDonBanHangResponse<T = any> {
  results: T[];
  count: number;
}

export const fetchAllBangTongHopHoaDonBanHang = async (
  entitySlug: string,
  body: Record<string, any> = {},
  pageSize = 200
): Promise<any[]> => {
  let page = 1;
  let all: any[] = [];
  let totalCount = 0;

  while (true) {
    const response = await api.post<BangTongHopHoaDonBanHangResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.BANG_TONG_HOP_HOA_DON_BAN_HANG}/`,
      body,
      {
        params: {
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    totalCount = response.data.count ?? totalCount;
    all = all.concat(pageResults);

    if (pageResults.length < pageSize || (totalCount && all.length >= totalCount)) {
      break;
    }

    page += 1;
  }

  return all;
};
